<template>
  <div>
    <Form :label-width="150">
      <!-- 基本信息 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.basicInformationElasticIP' )}}</p>
            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.cloudPlatform' )">
                  <span style="width: 200px;">{{accountTypeSearchKey}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.account' )">
                  <span style="width: 200px;">{{accountId}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.area' )">
                  <span style="width: 200px;">{{region}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.uses' )">
                  <span style="width: 200px;">{{use}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.periodofuse' )">
                  <span style="width: 200px;">{{periodOfUse}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.resourceType' )">
                  <span style="width: 200px;">{{resourceType}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.environment' )">
                  <span style="width: 200px;">{{environment}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.flow' )">
                  <span style="width: 200px;">{{approvalFlow}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.resourceGroup' )">
                  <span style="width: 200px;">{{resourceGroup}}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <!-- 资源配置 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.resourceConfiguration' )}}</p>
            <Row>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.name' )">
                  <span style="width: 200px;">{{name}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="11">
                <FormItem label="SKU:">
                  <span style="width: 200px;">{{sku}}</span>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label="$t( 'resourceLifecycle.assignment' )">
                  <span style="width: 200px;">{{assign}}</span>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <FormItem prop="enclosure">
                  <Table :no-data-text="$t('common.noData')" border :columns="columnsFile" :data="fileData" :border="false">
                    <template slot-scope="{row,index}" slot="download">
                      <!-- 下载 -->
                      <Button type="success" :loading="modal_loadings" size="small"
                              @click="downloadFile(row)">{{$t('resourceLifecycle.download')}}
                      </Button>
                    </template>
                  </Table>
                </FormItem>
              </Col>
            </Row>

            <Row>
              <Col span="22">
                <FormItem :label="$t( 'resourceLifecycle.remarkation' )">
                  <span style="width: 200px;">{{describe}}</span>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>


      <!-- 预估费用 -->
      <Row :gutter="10" style="margin-bottom: 10px;">
        <Col span="24">
          <Card>
            <p slot="title" style="line-height: 16px;font-size:13px;color:#000;height: 15px;">{{$t( 'resourceLifecycle.estimatedcosts' )}}</p>
            <Row>
              <Col span="12">
                <FormItem :label="$t( 'resourceLifecycle.estimatedcost' )">
                  <i style="font-size: 20px;">￥ {{cost}}</i>
                </FormItem>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
  export default {
    name: 'AmazonElasticAddressDetail',
    props: ['azureResourceApplicationBasicInfoForm'],
    components: {},
    data() {
      return {
        cost: 0,
        modal_loadings: false,//下载
        accountTypeSearchKey: '',
        accountId: '',
        region: '',
        use: '',
        periodOfUse: '',
        resourceType: '',
        environment: '',
        approvalFlow: '',
        name: '',
        resourceGroup: '',
        sku: '',
        assign: '',
        describe: '',
        columnsFile: [
          {
            title: this.$t( 'resourceLifecycle.filenames' ),
            key: 'fileName'
          },
          {
            title: this.$t( 'resourceLifecycle.fileType' ),
            key: 'fileType'
          },
          {
            title: this.$t('common.operation'),
            slot: 'download',
            "width": 100
          }],
        fileData: []
      }
    },
    mounted: function () {
      this.dealWithLine();
    },
    methods: {
      // 处理
      /****************************************************/
      dealWithLine: function () {
        // 审批
        this.$api.lifecycleResourceApplication.queryLifecycleResourceById({
          "id": this.azureResourceApplicationBasicInfoForm.id
        })
          .then(res => {
            // Common Params
            this.accountTypeSearchKey = res.data.platformString;
            this.accountId = res.data.accountName;
            this.region = res.data.region;
            this.use = res.data.usageNote;
            this.periodOfUse = res.data.duration + this.$t( 'resourceLifecycle.months' );
            this.resourceType = res.data.lifecycleResourceTypeDesc;
            this.environment = res.data.environmentDesc;
            this.approvalFlow = res.data.approvalFlow;
            this.describe = res.data.remark;
            this.cost = res.data.cost;
            if (res.data.attachmentList != null && res.data.attachmentList != undefined && res.data.attachmentList.length > 0) {
              this.fileData = res.data.attachmentList;
            }

            // 资源配置
            this.resourceGroup = res.data.lifecycleResourceAzureEip.resourceGroup;
            this.name = res.data.lifecycleResourceAzureEip.ipName;
            this.sku = res.data.lifecycleResourceAzureEip.sku;
            this.assign = res.data.lifecycleResourceAzureEip.type;
          })
      },
      // 下载附件
      /************************************************************/
      downloadFile: function (row) {
        // 下载附件
        this.modal_loadings = true;
        this.$api.file.downloadFile("id", row.id)
          .then(res => {
            let aTag = document.createElement('a');
            let blob = new Blob([res.data], {type: 'text/plain;charset=UTF-8'})
            aTag.download = row.fileName;
            aTag.href = URL.createObjectURL(blob);
            aTag.click();
            URL.revokeObjectURL(blob);
            setTimeout(() => {
              this.modal_loadings = false;
              this.$Message.success(this.$t( 'resourceLifecycle.response.downloadSuccess'));
            }, 1000);
          })
      }
    }
  }
</script>

<style scoped>
  .ivu-form-item {
    margin-bottom: 0px !important;
    vertical-align: top;
    zoom: 1;
  }
</style>




// WEBPACK FOOTER //
// src/components/resource_lifecycle_management/resource_application/azure/elastic_ip/AzureElasticAddressDetail.vue